import { Link } from "react-router-dom";
import { ChevronDown, Users, Check } from "lucide-react";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

const initial = (p) => (p ? p.name[0].toUpperCase() : "?");

export const ProfilePicker = ({ profiles, profile, onPick }) => (
  <DropdownMenu>
    <DropdownMenuTrigger asChild>
      <button className="pp-ghost pp-profile-btn" data-testid="profile-picker-trigger">
        <span className="pp-avatar">{initial(profile)}</span>
        <span className="hidden sm:inline">{profile ? profile.name : "Who's asking?"}</span>
        <ChevronDown className="h-4 w-4" />
      </button>
    </DropdownMenuTrigger>
    <DropdownMenuContent align="end" className="w-56 bg-white" data-testid="profile-picker-menu">
      <DropdownMenuLabel>Who's asking?</DropdownMenuLabel>
      {profiles.map((p) => (
        <DropdownMenuItem key={p.id} onSelect={() => onPick(p)} data-testid={`profile-option-${p.id}`}>
          <span className="pp-avatar sm">{initial(p)}</span> {p.name}
          <span className="ml-auto text-xs opacity-60">{p.age}</span>
          {profile?.id === p.id && <Check className="h-4 w-4" />}
        </DropdownMenuItem>
      ))}
      <DropdownMenuItem onSelect={() => onPick(null)} data-testid="profile-option-guest">
        <span className="pp-avatar sm">?</span> Guest
      </DropdownMenuItem>
      <DropdownMenuSeparator />
      <DropdownMenuItem asChild>
        <Link to="/family" data-testid="profile-manage-family-link"><Users className="h-4 w-4 mr-2" /> Family area (parents)</Link>
      </DropdownMenuItem>
    </DropdownMenuContent>
  </DropdownMenu>
);
